import shuffle from "lodash/shuffle";

class DataApi {
  constructor(rawData, interviewType) {
    this.rawData = rawData;
    this.interviewType = interviewType;
  }

  createPairs(pairs, projectObjects, aspects) {
    let output = [];
    if (pairs.length < 2) {
      return output;
    }
    pairs.forEach((pair, idx) => {
      const first = projectObjects.find(projectObject => {
        if (projectObject.id === pair.first) {
          return true;
        }
        return false;
      });

      const second = projectObjects.find(projectObject => {
        if (projectObject.id === pair.second) {
          return true;
        }
        return false;
      });

      const aspect = aspects[idx % aspects.length];

      output.push({
        projectObjects: [first, second],
        answered: true,
        skipped: false,
        answer: {
          term: aspect.term,
          opposite: aspect.opposite
        }
      });
    });
    return output;
  }

  setupData() {
    let aspects = this.rawData.project_aspect_pairs.map(data => ({
      ...data,
      added: new Date().toISOString(),
      description: "none"
    }));
    aspects = shuffle(aspects);

    let newData = {
      interviewType: this.interviewType,
      numOfElements: this.rawData.num_rounds,
      project: this.rawData.uuid,
      name: this.rawData.name,
      enabledProjectObjects: [],
      questions: [],
      aspects: aspects.map(aspect => ({ ...aspect })),
      objectPairs: [],
      projectObjects: []
    };

    this.rawData.project_objects.forEach(projectObject => {
      projectObject.aspects = aspects.map(aspect => ({
        ...aspect
      }));
      if (projectObject.enabled) {
        newData.enabledProjectObjects.push(projectObject);
      }
      newData.projectObjects.push(projectObject);
    });

    this.rawData.questions.forEach(question => {
      question.skipped = false;
      question.answered = false;
      question.answer = [];
      newData.questions.push(question);
    });

    newData.objectPairs = this.createPairs(
      this.rawData.project_object_pairs_projects,
      newData.projectObjects,
      aspects
    );
    newData.objectPairs = shuffle(newData.objectPairs);
    let i = 0;
    newData.objectPairs.forEach(objectPair => {
      objectPair.pairId = i++;
    });

    newData.enabledProjectObjects = shuffle(newData.enabledProjectObjects);
    newData.questions = shuffle(newData.questions);

    newData.output = {
      project: newData.project,
      questions: [],
      aspects: aspects.map(aspect => ({ ...aspect })),
      projectObjects: newData.projectObjects
    };

    return newData;
  }
}

export default DataApi;



// WEBPACK FOOTER //
// ./src/comparison-predefined/DataApi.js